import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ApiError } from '@/models/apiError';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (count, err) => err instanceof ApiError && err.status >= 500 && count < 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

interface QueryProviderProps {
  readonly children: React.ReactNode;
}

/** Provides the shared TanStack Query client; adds devtools in dev mode only. */
export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {import.meta.env.DEV ? (
        // `buttonPosition="top-left"`: both bottom corners collide with the footer's legal bar
        // (copyright bottom-left, Datenschutz/AGB/Impressum bottom-right) on short pages where
        // the footer sits at the viewport's bottom edge.
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-left" />
      ) : null}
    </QueryClientProvider>
  );
}
